// removed by extract-text-webpack-plugin
module.exports = {"maxarea":"Table__maxarea__1_fEX","fulltable":"Table__fulltable__UAgB1","wraptable":"Table__wraptable__1-5AS","table":"Table__table__aPumP","row":"Table__row__15KcZ","header":"Table__header__2BuUR","cell":"Table__cell__3zkLt","rowhighlight":"Table__rowhighlight__jUT0F","full":"Table__full__3FdZF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Table/Table.css
// module id = 177
// module chunks = 1